import React from 'react'
import styled from 'styled-components'
import {Image} from 'common/components'
import {IMAGE_ASSET} from 'consts/components'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 12px;
`

// const StyledHostContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   gap: 8px;
// `

export default function AuthLoginHeader() {
  return (
    <StyledContainer>
      <Image src={IMAGE_ASSET('giftshop', 'fotoyu.png')} alt="fotoyu" />
      {/* <StyledHostContainer>
        <Icon type="tree-feature" color="white_1" size={32} />
        <Paragraph fontSize="xl" fontWeight="bold" color="white_1">
          Jakarta Running Festival 2025
        </Paragraph>
      </StyledHostContainer> */}
    </StyledContainer>
  )
}
